export const MAX_FORGET_LENGTH = 5;
export const SMS_EXPIRE_DAYS = 14;
export const COOL_DOWN_TIME = 15; // minute
